const appConfig = {
  appName: "Freedom.mp3",
  appTagline: "Listen to freedom mp3 - Modern Galaxy Music Dashboard",
  defaultTitle: "Freedom mp3 | Stream Modern Galaxy Music",
  description:
    "Discover the ultimate freedom mp3 experience. A futuristic music streaming dashboard with immersive galaxy visuals and responsive UI for everyday discovery.",
  about: {
    title: "Freedom mp3 Experience",
    description:
      "The freedom mp3 experience is a modern music dashboard crafted for immersive listening. We blend futuristic interface design with focused playback controls for everyday discovery sessions. Enjoy streaming freedom mp3 tracks seamlessly.",
    contact: {
      email: "undefined.anonymou@gmail.com",
      website: "https://xqsadness.vercel.app/",
      github: "https://github.com/xqsadness/",
      location: "VN",
    },
    highlights: [
      "Modern Galaxy Aesthetic",
      "Responsive Mobile-First Layout",
      "Animated Player Experience",
      "Music Discovery Focus",
    ],
  },
};

export default appConfig;
